import { UserNameParserModel } from '@fleet-beat/shared';

export function parseUserName(user: UserNameParserModel): Partial<UserNameParserModel> {
  if (!user) {
    return { firstName: '', lastName: '' };
  }
  if (user.firstName && user.lastName) {
    return {
      firstName: user.firstName,
      lastName: user.lastName,
    };
  }

  const splitted: string[] = user.firstName.split(' ');
  const [firstName, ...lastName]: string[] = splitted;
  return { firstName, lastName: lastName.join(' ') };
}
